/* eslint-disable no-useless-escape */
export const PAGE_PATTERNS = [
  {
    pattern: /^\/$/,
    key: 'home',
    name: 'Home'
  },
  {
    pattern: /^\/dashboard$/,
    key: 'dashboard',
    name: 'Dashboard'
  },
  {
    pattern: /^\/learning-center$/,
    key: 'learningCenter',
    name: 'Learning Center'
  },
  {
    pattern: /^\/gift-catalog$/,
    key: 'productList',
    name: 'Gift Catalog'
  },
  {
    pattern: /^\/my-automations$/,
    key: 'AutomationList',
    name: 'Automation List'
  },
  {
    pattern: /^\/automation\/([^\/]+)$/,
    key: 'AutomationDetails',
    name: 'Automation Details'
  },
  {
    pattern: /^\/automation\/([^\/]+)\/contacts\/([^\/]+)$/,
    key: 'AutomationRecipientDetail',
    name: 'Automation Recipient Detail'
  },
  {
    pattern: /^\/collections$/,
    key: 'collections',
    name: 'Collections'
  },
  {
    pattern: /^\/collections\/saved$/,
    key: 'collections-saved',
    name: 'Saved Collections'
  },
  {
    pattern: /^\/collections\/featured$/,
    key: 'collections-featured',
    name: 'Featured Collections'
  },
  {
    pattern: /^\/collections\/([^\/]+)$/,
    key: 'collections-detail',
    name: 'Collection Detail'
  },
  {
    pattern: /^\/collections\/([^\/]+)\/edit$/,
    key: 'collections-detail-edit',
    name: 'Edit Collection'
  },
  {
    pattern: /^\/contacts$/,
    key: 'ContactList',
    name: 'Contact List'
  },
  {
    pattern: /^\/contacts\/tags$/,
    key: 'ContactTags',
    name: 'Contact Tags'
  },
  {
    pattern: /^\/contacts\/detail\/([^\/]+)$/,
    key: 'ContactDetail',
    name: 'Contact Detail'
  },
  {
    pattern: /^\/settings$/,
    key: 'settings',
    name: 'Settings'
  },
  {
    pattern: /^\/settings\/branding$/,
    key: 'branding',
    name: 'Branding'
  },
  {
    pattern: /^\/settings\/account$/,
    key: 'account',
    name: 'Account'
  },
  {
    pattern: /^\/settings\/payment-methods$/,
    key: 'payment-methods',
    name: 'Payment Methods'
  },
  {
    pattern: /^\/settings\/users$/,
    key: 'users',
    name: 'Users'
  },
  {
    pattern: /^\/settings\/users\/([^\/]+)$/,
    key: 'user-detail',
    name: 'User Detail'
  },
  {
    pattern: /^\/new-recognition\/gifts$/,
    key: 'NewRecognition',
    name: 'New Recognition Gifts'
  },
  {
    pattern: /^\/new-recognition\/recipients$/,
    key: 'NewRecognition',
    name: 'New Recognition Recipients'
  },
  {
    pattern: /^\/new-recognition\/sharing$/,
    key: 'NewRecognition',
    name: 'New Recognition Sharing'
  },
  {
    pattern: /^\/new-recognition\/experience$/,
    key: 'NewRecognition',
    name: 'New Recognition Experience'
  },
  {
    pattern: /^\/new-recognition\/review-and-pay\/([^\/]+)$/,
    key: 'NewRecognition',
    name: 'Review & Pay'
  },
  {
    pattern: /^\/new-recognition\/share\/([^\/]+)$/,
    key: 'NewRecognition',
    name: 'Share'
  },
  {
    pattern: /^\/my-recognitions\/thank-you-notes$/,
    key: 'Recognition',
    name: 'Thank You Notes'
  },
  {
    pattern: /^\/new-recognition\/order-confirmed\/([^\/]+)$/,
    key: 'Recognition',
    name: 'Order Confirmed'
  },
  {
    pattern: /^\/my-recognitions$/,
    key: 'RecognitionList',
    name: 'My Recognitions'
  },
  {
    pattern: /^\/recognition\/([^\/]+)$/,
    key: 'RecognitionDetail',
    name: 'Recognition Detail'
  },
  {
    pattern: /^\/recognition\/([^\/]+)\/recipients\/([^\/]+)$/,
    key: 'RecognitionDetail',
    name: 'Recognition Recipient Detail'
  },
  {
    pattern: /^\/new-automation\/gifts$/,
    key: 'NewAutomation',
    name: 'New Automation Gifts'
  },
  {
    pattern: /^\/new-automation\/rules$/,
    key: 'NewAutomation',
    name: 'New Automation Rules'
  },
  {
    pattern: /^\/new-automation\/recipients$/,
    key: 'NewAutomation',
    name: 'New Automation Recipients'
  },
  {
    pattern: /^\/new-automation\/experience$/,
    key: 'NewAutomation',
    name: 'New Automation Experience'
  },
  {
    pattern: /^\/new-automation\/review-and-active\/([^\/]+)$/,
    key: 'NewAutomation',
    name: 'Review & Active'
  },
  {
    pattern: /^\/new-automation\/order-confirmed\/([^\/]+)$/,
    key: 'NewAutomation',
    name: 'Order Confirmed'
  },
  {
    pattern: /^\/invite$/,
    key: 'invite',
    name: 'Invite'
  },
  {
    pattern: /^\/invite\/expired$/,
    key: 'expired',
    name: 'Invite Expired'
  },
  {
    pattern: /^\/sign-up$/,
    key: 'auth',
    name: 'Sign Up'
  },
  {
    pattern: /^\/login$/,
    key: 'auth',
    name: 'Sign In'
  },
  {
    pattern: /^\/logout$/,
    key: 'logout',
    name: 'Logout'
  },
  {
    pattern: /^\/validate$/,
    key: 'auth',
    name: 'Validation'
  },
  {
    pattern: /^\/select-organization$/,
    key: 'auth',
    name: 'Select Organization'
  },
  {
    pattern: /^\/under-maintenance$/,
    key: 'underMaintenance',
    name: 'Under Maintenance'
  },
  {
    pattern: /^\/send-gift\/([^\/]+)\/gift-list$/,
    key: 'SendGiftGiftList',
    name: 'Send Gift Gift List'
  },
  {
    pattern: /^\/send-gift\/([^\/]+)\/review$/,
    key: 'SendGiftReview',
    name: 'Send Gift Review'
  },
  {
    pattern: /^\/not-found$/,
    key: 'notFound',
    name: '404 Not Found'
  },
  {
    pattern: /^\/error$/,
    key: 'error',
    name: '503 Service Unavailable'
  },
  {
    pattern: /^\*$/,
    key: 'notFound',
    name: '404 Not Found'
  }
];
